import jsonp from "jsonp";
import axios from "axios";
import type { resType } from "../types/index";
import { getCurrentHost } from "@/utils";
export const HOST = getCurrentHost();
export const BRAND = HOST.split(".")[0];

export const convertParamToString = (
  params: { [x: string]: string | number } | undefined
) => {
  const paramArray: string[] = [];
  for (const key in params) {
    let val = params[key];
    if ("object" === typeof val) {
      val = JSON.stringify(val);
    }
    const param = key + "=" + val;
    paramArray.push(param);
  }
  paramArray.push("callback");
  if (paramArray.length > 0) {
    return paramArray.join("&");
  }
  return "";
};
export const assignQueryParam = (target) => {
  if (!target) {
    return "";
  }
  // 合并链接上的参数
  const queryParams = new URLSearchParams(window.location.search);
  Object.keys(target).forEach((item) => {
    queryParams.set(item, target[item]);
  });
  return queryParams.toString();
};

export default function getJSONP<T>(url: string, params?: T): Promise<resType> {
  return new Promise((resolve) => {
    jsonp(
      `${url}?${assignQueryParam(params)}`,
      {
        prefix: "jsonpCallback",
      },
      (err, res) => {
        err ? console.log(err) : resolve(res);
      }
    );
  });
}
const service = axios.create({
  withCredentials: true,
});
export const getData = (url, params) => {
  axios.get(`${url}?${assignQueryParam(params)}`);
};

export const postData = (url, data) => {
  return new Promise((resolve, reject) => {
    let promise = service.post(
      `${url}?${new URLSearchParams(window.location.search).toString()}`,
      data
    );
    promise
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
